module.exports = __webpack_public_path__ + "static/media/Inter-Bold.21ec20c9.woff";